/**
 * Markendarstellung greenius® homebase.
 *
 * Die freigegebenen Assets liegen unter public/assets/brand/ und werden
 * unveraendert verwendet. Es wurde kein Logo nachgebaut und keine
 * Markenvariante erfunden.
 *
 *   homebase-wordmark.png  kompakte Wortmarke -- Header und Navigation
 *   homebase-full.png      vollstaendige Fassung -- Anmeldeseite
 *   favicon.png            Signet -- Browser-Tab (in index.html eingebunden)
 */
import "./Brand.css";

const BRAND = "/assets/brand";

/** Kompakte Wortmarke fuer den Header. Bewusst klein gehalten. */
export function Wordmark(): React.JSX.Element {
  return (
    <img
      className="brand-mark brand-mark--compact"
      src={`${BRAND}/homebase-wordmark.png`}
      alt="greenius homebase"
      width={1200}
      height={236}
      decoding="async"
    />
  );
}

/** Vollstaendige Markenfassung fuer die Anmeldeseite. */
export function FullMark(): React.JSX.Element {
  return (
    <img
      className="brand-mark brand-mark--full"
      src={`${BRAND}/homebase-full.png`}
      alt="greenius homebase"
      width={1200}
      height={258}
      // Die Anmeldeseite ist das Erste, was ein Nutzer sieht.
      fetchPriority="high"
      decoding="async"
    />
  );
}
